<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/KPI/Index' }">绩效管理</el-breadcrumb-item>
                        <el-breadcrumb-item>查看KPI</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <!-- :class="currentRole.Key=='director'?'show':'hidden'" -->
                <el-col :span="20"  style="text-align:right;" :class="currentRole.Key=='director'?'show':'hidden'">
                    <el-button size="mini" type="primary" plain @click="LookKPI">查看KPI设置</el-button>
                </el-col>
                <!-- :class="currentRole.Key=='director'?(isShowSend?'show':'hidden'):'hidden'" -->
                <el-col :span="4" style="text-align:right;"  :class="currentRole.Key=='director'?(isShowSend?'show':'hidden'):'hidden'">
                    <el-button size="mini" :disabled="disabledMonth" type="success" plain @click="sendMonth">发送月度KPI</el-button>
                    <el-button size="mini" :disabled="disabledJD" type="warning" plain @click="sendJuDu">发送季度KPI</el-button>
                </el-col>
            </el-row>
            <el-tabs v-model="activeName">
                <el-tab-pane label="月度" name="month">
                    <LookKPIList :pt="0"></LookKPIList>
                </el-tab-pane>
                <el-tab-pane label="季度" name="quarter">
                    <LookKPIList :pt="1"></LookKPIList>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>
<script>
import LookKPIList from "../KPI/LookKPIList";
import { Decrypt, Encrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { SendFrameResult,MyUserKpi } from "../../until/ZeusApiSDK/Logic/KPILogic";
export default {
  data() {
    return {
      activeName: "month",
      isShowSend:false,//是否显示发送按钮
      disabledMonth:true,//月度发送按钮是否禁用
      disabledJD:true,//季度发送按钮是否禁用
      currentDept:{},//当前操作部门
      thisperiod:'',//当前操作周期
      currentRole:{},//获取当前用户角色
      currentUser:{},//获取当前用户
      pType:0,//0月度  1季度
    };
  },
  components: {
    LookKPIList
  },
  created() {
    //获取当前用户角色
    this.getCurrentRole();
    //获取当前用户
    this.getCurrentUser();
    //获取当前操作部门
    this.GetCurrentFrame();
  },
  methods:{
    //获取当前用户
    getCurrentUser:function(){
        var userinfo = window.sessionStorage.getItem("userinfo");
        userinfo = JSON.parse(Decrypt(userinfo));
        this.currentUser = userinfo;
    },
    //获取当前用户角色
    getCurrentRole:function(){
        var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
        this.currentRole = JSON.parse(Decrypt(currentUserRole));
        console.log('this.currentRole',this.currentRole);
        if(this.currentRole.Key=='director'){
          this.isShowSend=true;
          this.disabledMonth=false;
          this.disabledJD=false;
        }
        else{
          this.isShowSend=false;
          this.disabledMonth=true;
          this.disabledJD=true;
        }
    },
    //获取当前操作部门
    GetCurrentFrame:function(){
      var deptModelStory = window.sessionStorage.getItem("deptModel");
      console.log('deptModelStory',deptModelStory);
      if (deptModelStory) {
        this.currentDept = JSON.parse(Decrypt(deptModelStory));
        console.log('this.currentDept',this.currentDept);
        this.MyUserKpi();
      }
    },
    //获取操作周期
    getThisPeriod:function(){
        var thisperiod='';
        var month=new Date().getMonth() + 1;
        if(this.pType==1){
            //季度  当前季度
            if(month>=1&&month<=3){
                thisperiod='Q1';
            }
            else if(month>=4&&month<=6){
                thisperiod='Q2';
            }
            else if(month>=7&&month<=9){
                thisperiod='Q3';
            }
            else if(month>=10&&month<=12){
                thisperiod='Q4';
            }
        }else {
            //月度  当前月
            thisperiod=month;
        }
        this.thisperiod=thisperiod;
    },
    //发送月度KPI
    sendMonth:function(){
      this.pType=0;
      this.sendKPI(0);
    },   
    //发送季度KPI 
    sendJuDu:function(){
      this.pType=1;
      this.sendKPI(1);
    },
    //发送计划KPI  pType:0月度  1季度
    sendKPI:function(pType){
        this.disabledMonth=true;
        this.disabledJD=true;
        var date=new Date();
        var year=date.getFullYear();
        
        if(!this.currentDept||this.currentDept.value=='无'){
           this.$message.error('请选择操作部门');
        }

        //获取操作周期
        this.getThisPeriod();
        SendFrameResult(this.currentDept.value,pType,this.thisperiod,year,this.currentUser.UserCode,this.currentUser.UserId,0).then(res=>{
            this.disabledMonth=false;
            this.disabledJD=false;
            if(res.Result==1){
                this.$confirm( 
                '提示', 
                { 
                    title: '发送成功', 
                    message: '发送成功', 
                    showCancelButton: true, 
                    confirmButtonText: '确定', 
                    // cancelButtonText: '取消', 
                    type: 'warning'
                } ).then(() => {
                    //根据部门获取KPI列表
                    this.getFrameKpiList();
                    //判断当前是否已经发送
                    this.MyUserKpi();
                }).catch(() => {
                    //根据部门获取KPI列表
                    this.getFrameKpiList();
                    //判断当前是否已经发送
                    this.MyUserKpi();     
                });
                // //根据部门获取KPI列表
                // this.getFrameKpiList();
                // //判断当前是否已经发送
                // this.MyUserKpi();
            }
            else{
                 this.$message.error(res.Message);
            }
        });
    },
    //判断当前是否已经发送
    MyUserKpi:function(){
        //获取操作周期
        this.getThisPeriod();

        var date=new Date();
        var year=date.getFullYear();
        //月度是否已经发送  
        MyUserKpi(this.thisperiod,year,this.currentDept.value,0,this.currentRole.Key,this.currentUser.UserCode).then(res=>{
            if(res.result==0){
                this.disabledMonth=true;
            }
            else{
                this.disabledMonth=false;
            }
        });
        //季度  当前季度
        var judu='';
        if(this.thisperiod>=1&&this.thisperiod<=3){
            judu='Q1';
        }
        else if(this.thisperiod>=4&&this.thisperiod<=6){
            judu='Q2';
        }
        else if(this.thisperiod>=7&&this.thisperiod<=9){
            judu='Q3';
        }
        else if(this.thisperiod>=10&&this.thisperiod<=12){
            judu='Q4';
        }
        //季度是否已经发送  
        MyUserKpi(judu,year,this.currentDept.value,1,this.currentRole.Key,this.currentUser.UserCode).then(res=>{
            if(res.result==0){
                this.disabledJD=true;
            }
            else{
                this.disabledJD=false;
            }
        });
    },
    //查看中心KPI
    LookKPI:function(){
      window.location.href="/KPI/KPISetting";
    }
  }
}
</script>
<style lang="less" scoped>
.show{
  display: block;
}
.hidden{
  display: none;;
}
</style>
